module.exports = __webpack_public_path__ + "static/media/6-6.7a7ff3cf.mp3";